import { useEffect, useState } from "react";
import { useLiff } from "react-liff";

export function useLineUser() {
  const { liff, isReady } = useLiff();

  const [lineProfile, setLineProfile] = useState(null);

  useEffect(() => {
    if (liff && isReady) {
      try {
        // Only fetch profile if running inside LINE client
        if (liff.isInClient && liff.isInClient()) {
          liff.getProfile().then((profile) => {
            setLineProfile(profile);
          }).catch(() => {
            // Gracefully handle — not in LINE or profile unavailable
            setLineProfile(null);
          });
        }
      } catch {
        setLineProfile(null);
      }
    }
  }, [liff, isReady]);

  return { lineProfile };
}